import React from 'react';
import { AlignLeft2 } from '@good/icons';

import { useRichTextEditor } from '../rich-text-editor-context';
import { MenuButton } from './menu-button';

export const AlignLeftButton = () => {
  const { editor, disabled } = useRichTextEditor();

  const isDisabled = disabled || !editor.can().chain().focus().setTextAlign('left').run();
  const onClick = () => editor.chain().focus().setTextAlign('left').run();
  const variant = editor.isActive({ textAlign: 'left' }) ? 'filled' : 'transparent';

  return (
    <MenuButton onClick={onClick} disabled={isDisabled} variant={variant} aria-label='align-left'>
      <AlignLeft2 />
    </MenuButton>
  );
};
